<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import PickerMixin from "@/mixins/PickerMixin"

const { mapActions } = createNamespacedHelpers("squad")
export default {
  name: "SquadPicker",
  mixins: [PickerMixin],
  data: () => ({
    search: "",
    loading: false,
  }),

  computed: {
    items() {
      return this.$store.state.squad.data
    },
  },

  methods: {
    ...mapActions([FETCH]),

    itemText(item) {
      return item.name
    },
  },
}
</script>
